import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {concatMap, pluck, tap} from 'rxjs/operators';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
    selector: 'app-user-meta',
    templateUrl: './user-meta.component.html',
    styleUrls: ['./user-meta.component.scss'],
    standalone: false
})
export class UserMetaComponent implements OnInit {

  private readonly log: AppLogger;

  metadata = {};

  constructor(private http: HttpClient, private appLogger: AppLoggerService) {
    this.log = this.appLogger.createForClass(UserMetaComponent);
  }

  ngOnInit(): void {
    this.log.debug('Loading user metadata');
    /**
    this.auth.user$
      .pipe(
        concatMap((user) =>

          this.http.get(
            encodeURI(`https://pantry.eu.auth0.com/api/v2/users/${user.sub}`)
          )
        ),
        pluck('user_metadata'),
        tap((meta) => (this.metadata = meta))
      )
      .subscribe();
     **/
  }

}
